import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-asahyogascience',
    templateUrl: './asahyogascience.component.html',
    styleUrls: ['./asahyogascience.component.scss']
})
export class AsahyogascienceComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
